<template>
  <div class="container">
    <div class="row vh-100 d-flex justify-content-center">
      <div class="col-12 align-self-center">
        <div class="row">
          <div class="col-lg-5 mx-auto">
            <div class="card">
              <div class="card-body p-0 auth-header-box">
                <div class="text-center p-3">
                  <div class="logo logo-admin">
                    <img src="../assets/logo.png" height="50" alt="logo" class="auth-logo">
                  </div>
                  <h4 class="mt-3 mb-1 text-white font-18">پنل مدیریت</h4>
                  <p class="text-muted  mb-0">برای ادامه لطفا وارد حساب شوید</p>
                </div>
              </div>
              <div class="card-body">
                <AjaxForm route="auth/admin/login" :callback="loginCallback" class="form-horizontal auth-form my-4">

                      <div class="form-group">
                        <label for="username">نام کاربری</label>
                        <div class="input-group mb-3">
                          <input type="text" class="form-control" name="username" id="username" placeholder="نام کاربری">
                        </div>
                      </div><!--end form-group-->

                      <div class="form-group">
                        <label for="userpassword">رمز عبور</label>
                        <div class="input-group mb-3">
                          <input type="password" class="form-control" name="password" id="userpassword" placeholder="رمز عبور">
                        </div>
                      </div><!--end form-group-->

                      <div class="form-group row mt-4">
                        <div class="col-sm-6">
                          <div class="custom-control custom-switch switch-success">
                            <input type="checkbox" class="custom-control-input" id="customSwitchSuccess">
                            <label class="custom-control-label text-muted" for="customSwitchSuccess">به خاطر بسپار</label>
                          </div>
                        </div><!--end col-->
                        <div v-if="false" class="col-sm-6 text-right">
                          <router-link to="/" class="text-muted font-13"><i class="dripicons-lock"></i>فراموشی رمز عبور؟</router-link>
                        </div><!--end col-->
                      </div><!--end form-group-->

                      <div class="form-group mb-0 row">
                        <div class="col-12 mt-2">
                          <button class="btn btn-primary btn-block waves-effect waves-light" type="submit">ورود<i class="fas fa-sign-in-alt ml-1"></i></button>
                        </div><!--end col-->
                      </div> <!--end form-group-->
                </AjaxForm>
              </div><!--end card-body-->
            </div><!--end card-->
          </div><!--end col-->
        </div><!--end row-->
      </div><!--end col-->
    </div><!--end row-->
  </div>
</template>

<script>
import AjaxForm from "@/components/forms/AjaxForm";
import {showSystemNoti} from "@/shared/helper";
import {mapActions, mapGetters} from "vuex";
export default {
  name: "Login",
  components: {AjaxForm},
  beforeMount()
  {
    document.body.classList.add('login-body');
    this.setShowHead(false);
  },
  unmounted()
  {
    document.body.classList.remove('login-body')
  },
  methods:{
    ...mapActions('auth',{
      loginUser : 'loginUser',
    }),
    ...mapActions('app',{
      setShowHead : 'setShowHead'
    }),
    async loginCallback(data)
    {
      const self = this;
      if (data.ok)
      {
        const result = await this.loginUser(data);
        return showSystemNoti('success','با موفقیت وارد شدید.',function (){
          self.$router.replace('/');
        })
      }
      else
          return showSystemNoti('danger',data.error)
    }
  },
  computed: {
    ...mapGetters('app', {
      pageTitle: 'pageTitle',
      showHead: 'showHead',
    })
  }
}
</script>

<style scoped>
.auth-header-box {
  background-color: #0c213a;
}
</style>
